<div class="container">
  <h1 class="m-b--16 text-center" i18n>Create your profile fast and easy by few clicks</h1>
  <p class="text-center m-b--48 subtitle" i18n>
    Create your artist profile by importing data from multiple channels as Youtube, Spotify and Mixcloud.
  </p>

  <app-artist-import-form></app-artist-import-form>
</div>
